export default __webpack_public_path__ + "static/media/in~qCXJxIbs.fe52987f.svg";